import { Component, OnInit } from "@angular/core";
import { AppService } from "../app.service";
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: "app-refund-policy",
  templateUrl: "./refund-policy.component.html",
  styleUrls: ["./refund-policy.component.css"],
})
export class RefundPolicyComponent implements OnInit {
  data: any;
  errStatus: boolean;
  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService
  ) {
    window.scrollTo(0, 0);
  }
  ngOnInit(): void {
    this.spinner.show();
    this.appService.footerContent({ type: "refund_policy" }).subscribe((res) => {
      if (res) {
        this.spinner.hide();
        this.data = res;
      } else {
        this.spinner.hide();
        this.data = [];
      }
    }, err => {
      if (err) {
        this.spinner.hide();
        this.data = [];
        this.errStatus = true;
      }
    });
  }
}
